<template>
    <div class="disclaimer">
        <p v-bastards>
            Wyrażam zgodę na przetwarzanie moich danych osobowych przez MAKRO Cash and Carry Polska S.A. z siedzibą w Warszawie (02-486), Al. Jerozolimskie 186 („MAKRO”) w celu otrzymywania pod podany adres poczty elektronicznej (otrzymywanie wiadomości e-mail) i/lub numer telefonu (otrzymywanie wiadomości sms, mms oraz połączeń przychodzących), oznaczonych „TAK”, informacji o kampaniach marketingowych, ofertach specjalnych, usługach, promocjach i wydarzeniach organizowanych przez MAKRO a także kontaktowania się na potrzeby badania opinii klientów.
        </p>
        <p v-bastards>
            Wyrażenie zgody jest dobrowolne i możesz ją wycofać w dowolnym momencie, zawiadamiając o tym MAKRO (np. na stronie www.zgody.makro.pl, pod adresem email:  zgody@makro.pl, osobiście w hali MAKRO). Cofnięcie zgody nie wpłynie na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. Nieudzielenie lub cofnięcie zgody nie wywiera dla Ciebie żadnych niekorzystnych konsekwencji.
        </p>
        <p v-bastards>
            Administratorem Twoich danych osobowych jest MAKRO.
        </p>
        <p v-bastards>
            We wszelkich kwestiach związanych z przetwarzaniem Twoich danych osobowych przez MAKRO, możesz skontaktować się z naszym Inspektorem Ochrony Danych w następujący sposób: listownie, adres do korespondencji jak wyżej, e-mail: ochrona.danych@makro.pl
        </p>
        <p v-bastards>
            Cele przetwarzania Twoich danych osobowych oraz podstawa prawna
        </p>
        <p v-bastards>
            Będziemy przetwarzać Twoje dane osobowe w celu prowadzenia wobec Ciebie ww. działań marketingowych, w tym kontaktowania się z Tobą przez e-mail i/lub telefon oraz kierowanie do Ciebie ankiet dot. badania satysfakcji klientów. Podstawą prawną tego przetwarzania jest Twoja zgoda (art. 6 ust. 1 lit. a RODO), a także nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO), którym jest informowanie klientów o naszych ofertach i usługach i o rozwijaniu współpracy z klientami oraz poprawa jakości naszych usług.
        </p>
        <p v-bastards>
            Twoje dane mogą podlegać profilowaniu. Takie przetwarzanie danych ułatwia nam lepsze poznanie Twoich zainteresowań i potrzeb oraz umożliwia nam uwzględnianie tych potrzeb i podejmowanie odpowiednich działań, np. komunikowanie się z Tobą w sposób zindywidualizowany. Twoje dane nie będą przetwarzane w sposób zautomatyzowany, tj. bez ingerencji człowieka.
        </p>
        <p v-bastards>
            Czy musisz podać nam swoje dane osobowe?
        </p>
        <p v-bastards>
            Podanie danych w celach marketingowych jest całkowicie dobrowolne.
        </p>
        <p v-bastards>
            Komu przekazywane są Twoje dane osobowe i gdzie są przetwarzane?
        </p>
        <p v-bastards>
            Twoje dane osobowe mogą być przekazywane podmiotom współpracującym z MAKRO lub naszym podwykonawcom w celu zapewnienia jak najwyższej jakości usług dopasowanych do Twoich potrzeb, w szczególności dostawcom usług i systemów informatycznych, agencjom marketingowym firmom kurierskim i pocztowym, drukarniom, dostawcom usług consultingowych, prawnych lub audytowych, podmiotom świadczącym usługi promocji sprzedaży, usługi badania rynku i opinii.
        </p>
        <p v-bastards>
            Korzystamy również z usług podmiotów zewnętrznych prowadzących działalność poza terytorium Unii Europejskiej. Zapewniamy, że w takim przypadku przekazywanie danych odbywać się będzie w oparciu o stosowną umowę pomiędzy MAKRO a tym podmiotem, zawierającą standardowe klauzule ochrony danych przyjęte przez Komisję Europejską i zapewniającą przetwarzanie danych osobowych zgodnie z europejskimi uregulowaniami ochrony danych.
        </p>
        <p v-bastards>
            Jak długo przechowujemy Twoje dane osobowe?
        </p>
        <p v-bastards>
            Twoje dane będą przechowywane do czasu cofnięcia przez Ciebie zgody (a w przypadku przetwarzania danych na podstawie uzasadnionego interesu – do czasu wniesienia sprzeciwu wobec ich przetwarzania) lub zakończenia procesu przetwarzania. Okres przetwarzania danych osobowych może zostać każdorazowo przedłużony o okres przedawnienia roszczeń, jeżeli przetwarzanie danych osobowych będzie niezbędne dla dochodzenia ewentualnych roszczeń lub obrony przed takimi roszczeniami.
        </p>
        <p v-bastards>
            Jakie przysługują Ci prawa?
        </p>
        <p v-bastards>
            Przysługuje Ci prawo dostępu do Twoich danych oraz ich sprostowania, usunięcia, ograniczenia przetwarzania, jak również prawo do przenoszenia danych osobowych oraz prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych, gdy uznasz, że przetwarzanie Twoich danych osobowych narusza przepisy prawa.
        </p>
        <p v-bastards>
            Przysługuje Ci ponadto prawo do wniesienia sprzeciwu wobec przetwarzania Twoich danych na potrzeby marketingu bezpośredniego, w tym profilowania oraz prawo do wniesienia sprzeciwu wobec przetwarzania Twoich danych, w tym profilowania, gdy ich przetwarzanie odbywa się na podstawie prawnie uzasadnionego interesu, a sprzeciw jest uzasadniony Twoją szczególną sytuacją.
        </p>
        <p v-bastards>
            Polityka prywatności
        </p>
        <p v-bastards>
            Szczegółowe zasady dotyczące przetwarzania danych osobowych w MAKRO są opisane w „Polityce prywatności” dostępnej na naszej stronie internetowej www.makro.pl lub w hali MAKRO.
        </p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.disclaimer {
    p {
        & + p {
            margin-top: .8em;
        }
    }
}
</style>
